module.exports = __webpack_public_path__ + "static/full07-fc347ec4a23b866bb4c8428b116b03d2.png";